import React, { useState } from 'react';
import DOMPurify from 'dompurify';

function Modal({ isOpen, onClose, onSubmit, loading, password, onPasswordChange, children }) {
    const [errorMessage, setErrorMessage] = useState('');

    if (!isOpen) return null;

    const handleSubmit = () => {
        const sanitizedPassword = DOMPurify.sanitize(password.trim());
        if (!sanitizedPassword || sanitizedPassword.length < 5) {
            setErrorMessage('Das Passwort muss mindestens 5 Zeichen lang sein.');
            return;
        }
        setErrorMessage('');
        onSubmit();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content">
                {children || (
                    <>
                        <h2 className="modal-title">Passwort eingeben, um fortzufahren</h2>
                        <input
                            type="password"
                            placeholder="Passwort eingeben"
                            value={password}
                            onChange={(e) => {
                                setErrorMessage('');
                                onPasswordChange(e);
                            }}
                            autoComplete="off"
                            className="modal-input"
                        />
                        {errorMessage && <p className="modal-error">{errorMessage}</p>}
                        <div className="modal-buttons">
                            <button 
                                onClick={handleSubmit} 
                                disabled={loading} 
                                className="modal-btn modal-btn-primary"
                            >
                                {loading ? 'Überprüfe Passwort...' : 'Firma bearbeiten'}
                            </button>
                            <button 
                                onClick={onClose} 
                                className="modal-btn modal-btn-secondary"
                            >
                                Abbrechen
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Modal;